import React from "react";
import { useTranslation } from "react-i18next";

const HeroAbout = () => {
  const { t, i18n } = useTranslation("about");
  const isRTL = i18n.language === "ar";

  return (
      <section className="bg-[#1C75BC] relative flex h-[40rem] justify-between items-center py-32 text-center md-max:h-80 md-max:py-14 px-20 md-max:px-4">
        <div className="flex flex-col gap-10 w-[90%] md-max:w-full md-max:max-w-full">
        <h1 className={`${isRTL ? "text-right" : "text-left"} md-max:text-center z-30 text-8xl font-bold text-white md-max:text-4xl`}>
        {t("hero.title")}
        </h1>
        <p className={`text-white font-semibold ${isRTL ? "text-right" : "text-left"} text-2xl md-max:text-xl z-30 md-max:text-center`}>{t("hero.description")}</p>
        </div>
        <img
          src={"/about-1.png"}
          alt="Rail Rolls"
          className="w-[35%] rounded-4xl mt-[15rem] md-max:hidden object-cover md-max:-mt-30 md-max:h-50 md-max:max-w-[80%] z-30"
        />
        <img src="/hero-about-elipse.png" alt="img" className="absolute top-0 left-0 h-1/2 z-10" />
      </section>
  );
};

export default HeroAbout;
